export function getFontColorForBackground(color: string) {
  if (!color.startsWith('#') || (color.length != 4 && color.length != 7)) {
    console.warn(
      "The value '" +
        color +
        "' could not be parsed as a color. Only 3/6 digit hexes are accepted (#ABC or #123456)"
    );

    return 'red';
  }

  const r =
    color.length == 4
      ? Number.parseInt(color.charAt(1), 16) / 15
      : Number.parseInt(color.substr(1, 2), 16) / 255;
  const g =
    color.length == 4
      ? Number.parseInt(color.charAt(2), 16) / 15
      : Number.parseInt(color.substr(3, 2), 16) / 255;
  const b =
    color.length == 4
      ? Number.parseInt(color.charAt(3), 16) / 15
      : Number.parseInt(color.substr(5, 2), 16) / 255;

  return 0.299 * r + 0.587 * g + 0.114 * b > 0.5 ? 'black' : 'white';
}
